import { useDataChange, useDataValue } from 'Simple/Data.js'

let ENTITY_TYPE_TO_RTYPES = /** @type {const} */ ({
  INVOICE: ['Invoice', 'Autopay'],
  CLAIM: ['Insurance', 'InitClaim', 'ContClaim', 'ProcClaim'],
})

export function useOnFilterClickClaims(props) {
  let current = useDataValue({
    context: 'tab',
    path: 'selected.ledger.receivables.filter_by',
    viewPath: props.viewPath,
  })

  let change = useDataChange({
    context: 'tab',
    path: 'selected.ledger.receivables.filter_by',
    viewPath: props.viewPath,
  })

  return function onClick() {
    // If currently showing all (empty array), start selecting this type
    if (current.length === 0) {
      change(['CLAIM'])
      return
    }

    // Toggle claim in the array
    if (current.includes('CLAIM')) {
      let newSelected = current.filter(item => item !== 'CLAIM')
      change(newSelected)
    } else {
      change([...current, 'CLAIM'])
    }
  }
}

export function getCount(receivables, entityType) {
  let allowedRtypes = ENTITY_TYPE_TO_RTYPES[entityType] || [entityType]
  return receivables.filter(item => allowedRtypes.includes(item.rtype)).length
}
